import { resolveCloudScreenshotUrl } from "../../../../lib/utils";

const CUSTOM_SCREENSHOTS_BASE = "instructions/screenshots";
const cloudScreenshot = (relativePath) => resolveCloudScreenshotUrl(`${CUSTOM_SCREENSHOTS_BASE}/${relativePath}`);

export const MISSION_FIVE_SCREENSHOT_LAYOUT_BY_PAGE = {
  m501: {
    src: cloudScreenshot(`screenshots_m5/instructions 5.01.svg`),
    title: "NEXT MISSION",
    leftPercent: 50,
    topPercent: 10,
    widthPercent: 42,
    maxWidthPercent: 48,
    titleWidthPercent: 28,
    titleLeftPercent: 50,
    titleTopVw: -0.25,
  },
  m502: {
    src: cloudScreenshot(`screenshots_m5/instructions 5.02.svg`),
    title: "Chasing alone vs. together",
    leftPercent: 50,
    topPercent: 10,
    widthPercent: 42,
    maxWidthPercent: 48,
    details: [
      {
        left: 49.20,
        top: 51.2,
        key: "KeyZ",
        className: "m502-keyz-hint",
        fontSizeVw: 0.54,
        color: "#DE5700",
        textStroke: "0",
      },
      {
        left: 55.65,
        top: 51.2,
        key: "Slash",
        className: "m502-slash-hint",
        fontSizeVw: 0.54,
        color: "#DE5700",
        textStroke: "0",
      },
    ],
    titleWidthPercent: 28,
    titleLeftPercent: 50,
    titleTopVw: -0.25,
  },
  m503: {
    src: cloudScreenshot(`screenshots_m5/instructions 5.03.svg`),
    title: "Chasing Alone (1/3)",
    leftPercent: 50,
    topPercent: 10,
    widthPercent: 42,
    maxWidthPercent: 48,
    details: [
      { left: 51.8, top: 51, key: "KeyS", fontSizeVw: 0.74 },
      { left: 53.3, top: 51, key: "KeyD", fontSizeVw: 0.74 },
      { left: 54.7, top: 51, key: "KeyF", fontSizeVw: 0.74 },
      { left: 56.65, top: 51, key: "KeyK", fontSizeVw: 0.74 },
      { left: 58.1, top: 51, key: "KeyL", fontSizeVw: 0.74 },
      { left: 59.5, top: 51, key: "Semicolon", fontSizeVw: 0.74 },
    ],
    titleWidthPercent: 28,
    titleLeftPercent: 50,
    titleTopVw: -0.25,
  },
  m504: {
    src: cloudScreenshot(`screenshots_m5/instructions 5.04.svg`),
    title: "Chasing Alone (2/3)",
    leftPercent: 56.876,
    topPercent: 10,
    widthPercent: 55.7,
    maxWidthPercent: 55.7,
    details: [
      { left: 51.8, top: 51, key: "KeyS", fontSizeVw: 0.74 },
      { left: 53.3, top: 51, key: "KeyD", fontSizeVw: 0.74 },
      { left: 54.7, top: 51, key: "KeyF", fontSizeVw: 0.74 },
      { left: 56.65, top: 51, key: "KeyK", fontSizeVw: 0.74 },
      { left: 58.1, top: 51, key: "KeyL", fontSizeVw: 0.74 },
      { left: 59.5, top: 51, key: "Semicolon", fontSizeVw: 0.74 },
    ],
    titleWidthPercent: 28,
    titleLeftPercent: 50,
    titleTopVw: -0.25,
  },
  m505: {
    src: cloudScreenshot(`screenshots_m5/instructions 5.05.svg`),
    title: "Chasing Alone (3/3)",
    leftPercent: 50,
    topPercent: 10,
    widthPercent: 42,
    maxWidthPercent: 48,
    titleWidthPercent: 28,
    titleLeftPercent: 50,
    titleTopVw: -0.25,
  },
  m506: {
    src: cloudScreenshot(`screenshots_m5/instructions 5.06.svg`),
    title: "Chasing together (1/2)",
    leftPercent: 50,
    topPercent: 10,
    widthPercent: 42,
    maxWidthPercent: 48,
    details: [
      { left: 51.8, top: 51, key: "KeyS", fontSizeVw: 0.74 },
      { left: 53.3, top: 51, key: "KeyD", fontSizeVw: 0.74 },
      { left: 54.7, top: 51, key: "KeyF", fontSizeVw: 0.74 },
      { left: 56.65, top: 51, key: "KeyK", fontSizeVw: 0.74 },
      { left: 58.1, top: 51, key: "KeyL", fontSizeVw: 0.74 },
      { left: 59.5, top: 51, key: "Semicolon", fontSizeVw: 0.74 },
    ],
    titleWidthPercent: 28,
    titleLeftPercent: 50,
    titleTopVw: -0.25,
  },
  m507: {
    src: cloudScreenshot(`screenshots_m5/instructions 5.07.svg`),
    title: "Chasing together (2/2)",
    leftPercent: 56.876,
    topPercent: 10,
    widthPercent: 55.7,
    maxWidthPercent: 55.7,
    details: [
      { left: 51.8, top: 51, key: "KeyS", fontSizeVw: 0.74 },
      { left: 53.3, top: 51, key: "KeyD", fontSizeVw: 0.74 },
      { left: 54.7, top: 51, key: "KeyF", fontSizeVw: 0.74 },
      { left: 56.65, top: 51, key: "KeyK", fontSizeVw: 0.74 },
      { left: 58.1, top: 51, key: "KeyL", fontSizeVw: 0.74 },
      { left: 59.5, top: 51, key: "Semicolon", fontSizeVw: 0.74 },
    ],
    titleWidthPercent: 28,
    titleLeftPercent: 50,
    titleTopVw: -0.25,
  },
  m508: {
    src: cloudScreenshot(`screenshots_m5/instructions 5.08.svg`),
    title: "Communication with Partners (1)",
    leftPercent: 58.742,
    topPercent: 10,
    widthPercent: 59.5,
    maxWidthPercent: 59.5,
    details: [
      { left: 51.8, top: 51, key: "KeyS", fontSizeVw: 0.68 },
      { left: 53.3, top: 51, key: "KeyD", fontSizeVw: 0.68 },
      { left: 54.8, top: 51, key: "KeyF", fontSizeVw: 0.68 },
      { left: 57.1, top: 51, key: "KeyK", fontSizeVw: 0.68 },
      { left: 58.5, top: 51, key: "KeyL", fontSizeVw: 0.68 },
      { left: 60.1, top: 51, key: "Semicolon", fontSizeVw: 0.68 },
    ],
    titleWidthPercent: 28,
    titleLeftPercent: 50,
    titleTopVw: -0.25,
  },
  m509: {
    src: cloudScreenshot(`screenshots_m5/instructions 5.09.svg`),
    title: "Communication with Partners (2)",
    leftPercent: 50,
    topPercent: 10,
    widthPercent: 42,
    maxWidthPercent: 48,
    titleWidthPercent: 28,
    titleLeftPercent: 50,
    titleTopVw: -0.25,
  },
  m510: {
    src: cloudScreenshot(`screenshots_m5/instructions 5.10.svg`),
    title: "Ready to Play",
    leftPercent: 50,
    topPercent: 10,
    widthPercent: 45,
    maxWidthPercent: 45,
    titleWidthPercent: 28,
    titleLeftPercent: 50,
    titleTopVw: -0.25,
  },
};
